export default __webpack_public_path__ + "static/media/EESymbolsImg6.7f1844fb.jpg";